import { render } from "./CreateAnnotationReviewTaskModal.vue?vue&type=template&id=127f2e6d&scoped=true"
import script from "./CreateAnnotationReviewTaskModal.vue?vue&type=script&lang=js"
export * from "./CreateAnnotationReviewTaskModal.vue?vue&type=script&lang=js"

import "./CreateAnnotationReviewTaskModal.vue?vue&type=style&index=0&id=127f2e6d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127f2e6d"]])

export default __exports__